import { createRouter, createWebHashHistory } from 'vue-router'
import Admin from "../views/Admin.vue";
import AdminAdd from "../views/AdminAdd.vue";
//import Expo from "../views/Expo.vue";
import AddResource from "../views/AddResource.vue";
import EditResource from "../views/EditResource.vue";
import AddHomePage from "../views/AddHomePage.vue";
import Parameter from "../views/Parameter.vue"
import Intermediate from "../views/Intermediate.vue";
import AddPoint from "../views/AddPoint.vue";
import Association from "../views/PointResourceAssociation.vue";
import Template_1 from "../views/templates/template_1.vue";
import Template_2 from "../views/templates/template_2.vue";
import Template_3 from "../views/templates/template_3.vue";
import Template_4 from "../views/templates/template_4.vue";
import Template_5 from "../views/templates/template_5.vue";
import Template_6 from "../views/templates/template_6.vue";
import Template_7 from "../views/templates/template_7.vue";
import Template_8 from "../views/templates/template_8.vue";
import Template_9 from "../views/templates/template_9.vue";
import Template_10 from "../views/templates/template_10.vue";
import Template_11 from "../views/templates/template_11.vue";
import Template_12 from "../views/templates/template_12.vue";
import Template_13 from "../views/templates/template_13.vue";
import Template_14 from "../views/templates/template_14.vue";
import Template_15 from "../views/templates/template_15.vue";
import Template_16 from "../views/templates/template_16.vue";
import Template_17 from "../views/templates/template_17.vue";
import Template_18 from "../views/templates/template_18.vue";
import Template_19 from "../views/templates/template_19.vue";
import Template_20 from "../views/templates/template_20.vue";
import Template_21 from "../views/templates/template_21.vue";
import Template_22 from "../views/templates/template_22.vue";
import Template_23 from "../views/templates/template_23.vue";
import Template_24 from "../views/templates/template_24.vue";
import Template_25 from "../views/templates/template_25.vue";
import Expo_bu from "../views/Expo_bu.vue";
import Creation_bu from "../views/Creation_bu.vue";
import ResourceManagement from "../views/ResourceManagement.vue";
import AssociationManagement from "../views/AssociationManagement.vue"
import TemplateManagement from "../views/TemplateManagement.vue";
import Archives from "../views/Archives.vue";
import QuizView from "../views/QuizView.vue";
//import Home from "../views/Home.vue"
import Login from "../views/Login.vue";
import { auth } from "../main.js"; // Import Firebase auth
import { demarrerAlpaFeedback } from "../alpa-feedback.js";
import AOS from "aos";
import 'aos/dist/aos.css';


const routes = [
  {
    path:'/',
    name: "Login",
    component: Login
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    
  },
  {
    path: '/admin/add',
    name: 'AdminAdd',
    component: AdminAdd,
    
  },
  {
    path: '/expo/:id',
    name: 'Expo',
    component: Expo_bu,
    
  },
  {
    path: '/addResource',
    name: 'AddResource',
    component: AddResource,
    
  },
  {
    path: '/editResource',
    name: 'EditResource',
    component: EditResource,
    
  },
  {
    path: '/addHomePage',
    name: 'AddHomePage',
    component: AddHomePage
  },
  {
    path: '/parameter',
    name: 'Parameter',
    component: Parameter
  },
  {
    path: '/point',
    name: 'Point',
    component: AddPoint
  },
  {
    path: '/association',
    name: 'Association',
    component: Association
  },
  {
    path: '/intermediate',
    name: 'Intermediate',
    component: Intermediate
  },
  {
    path: '/archives',
    name: 'Archives',
    component: Archives,
  },
  {
    path: '/quiz/:id',
    name: 'Quiz',
    component: QuizView,
  },
  {
    path: '/expo/template_1/:id',
    name : 'Template_1',
    component: Template_1,
  },
  {
    path: '/expo/template_2/:id',
    name : 'Template_2',
    component: Template_2
  },
  {
    path: '/expo/template_3/:id',
    name : 'Template_3',
    component: Template_3
  },
  {
    path: '/expo/template_4/:id',
    name : 'Template_4',
    component: Template_4
  },
  {
    path: '/expo/template_5/:id',
    name : 'Template_5',
    component: Template_5
  },
  {
    path: '/expo/template_6/:id',
    name : 'Template_6',
    component: Template_6
  },
  {
    path: '/expo/template_7/:id',
    name : 'Template_7',
    component: Template_7
  },
  {
    path: '/expo/template_8/:id',
    name : 'Template_8',
    component: Template_8
  },
  {
    path: '/expo/template_9/:id',
    name : 'Template_9',
    component: Template_9
  },
  {
    path: '/expo/template_10/:id',
    name : 'Template_10',
    component: Template_10
  },
  {
    path: '/expo/template_11/:id',
    name : 'Template_11',
    component: Template_11
  },
  {
    path: '/expo/template_12/:id',
    name : 'Template_12',
    component: Template_12
  },
  {
    path: '/expo/template_13/:id',
    name : 'Template_13',
    component: Template_13
  },
  {
    path: '/expo/template_14/:id',
    name : 'Template_14',
    component: Template_14
  },
  {
    path: '/expo/template_15/:id',
    name : 'Template_15',
    component: Template_15
  },
  {
    path: '/expo/template_16/:id',
    name : 'Template_16',
    component: Template_16
  },
  {
    path: '/expo/template_17/:id',
    name : 'Template_17',
    component: Template_17
  },
  {
    path: '/expo/template_18/:id',
    name : 'Template_18',
    component: Template_18
  },
  {
    path: '/expo/template_19/:id',
    name : 'Template_19',
    component: Template_19
  },
  {
    path: '/expo/template_20/:id',
    name : 'Template_20',
    component: Template_20
  },
  {
    path: '/expo/template_21/:id',
    name : 'Template_21',
    component: Template_21
  },
  {
    path: '/expo/template_22/:id',
    name : 'Template_22',
    component: Template_22
  },
  {
    path: '/expo/template_23/:id',
    name : 'Template_23',
    component: Template_23
  },
  {
    path: '/expo/template_24/:id',
    name : 'Template_24',
    component: Template_24
  },
  {
    path: '/expo/template_25/:id',
    name : 'Template_25',
    component: Template_25
  },
  {
    path: '/creation',
    name: 'Creation',
    component: Creation_bu
  },
  {
    path: '/resourceManagement',
    name: 'ResourceManagement',
    component: ResourceManagement
  },
  {
    path: '/associationManagement',
    name: 'AssociationManagement',
    component: AssociationManagement
  },
  {
    path: '/templateManagement',
    name: 'TemplateManagement',
    component: TemplateManagement
  }


]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export let lastRoute = null;


router.beforeEach((to, from, next) => {
  lastRoute = from;
  // get current user info
  AOS.init(); // Initialize AOS
  
  const currentUser = auth.currentUser;
  // Widget de retours : amorçage seulement. Il ne reçoit pas la route, et c'est
  // la condition pour qu'un enregistrement vidéo survive à une navigation.
  demarrerAlpaFeedback();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if(requiresAuth && !currentUser) next('/');
  //else if(!requiresAuth && currentUser) next("/admin")
  else next();
})

export default router
